var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-center" },
          [
            _c("b-spinner", {
              staticStyle: { width: "3rem", height: "3rem" },
              attrs: { variant: "success", label: "Spinning" },
            }),
          ],
          1
        )
      : _vm._e(),
    !_vm.loading
      ? _c(
          "div",
          [
            _c(
              "form-wizard",
              {
                ref: "formWiz",
                staticClass: "mb-3",
                attrs: {
                  color: "#B1D06C",
                  title: null,
                  subtitle: null,
                  shape: "square",
                  "finish-button-text": "Submit",
                  "back-button-text": "Previous",
                },
                on: { "on-complete": _vm.formSubmitted },
              },
              [
                _c(
                  "tab-content",
                  {
                    attrs: {
                      title: "Details",
                      "before-change": _vm.ValidateRawMaterials,
                    },
                  },
                  [
                    _c("addproduct", {
                      ref: "RawMaterialDetails",
                      on: { formUpdate: _vm.getRawData },
                    }),
                  ],
                  1
                ),
                _c(
                  "tab-content",
                  { attrs: { title: "Finish" } },
                  [
                    _c(
                      "b-container",
                      {
                        staticClass:
                          "d-flex justify-content-center last_step flex-column",
                      },
                      [
                        _c("img", {
                          staticStyle: { height: "200px" },
                          attrs: { src: require("./check-mark.svg"), alt: "" },
                        }),
                        _c(
                          "h2",
                          { staticClass: "text-center mt-3 text-primary" },
                          [_vm._v("Submit and Confirm")]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }